import React, {Component} from 'react';
import ImageUploader from 'react-images-upload';
import ImagesUploader from 'react-images-uploader';
import 'react-images-uploader/styles.css';
import Video from '../trainer/unit/Video';
import Youtube from '../trainer/unit/Youtube';
import Audio from '../trainer/unit/Audio';
import {Link} from 'react-router-dom';
import ZoomLive from '../trainer/unit/ZoomLive';
import TextPdf from '../trainer/unit/TextPdf';
import Constant from '../../Constant';
//import HtmlUpload from '../trainer/unit/HtmlUpload';
export default class AddTopic extends Component {
  state = {
    name: '',
    enableCourseName: false,
    enableCourseDisc: false,
    courseName: 'Give your course a name',
    courseDisc:
      'Add a description of your course. Keep it clear and interesting for your learners.',
    selectedUnitType: 0,
    selectedOption: 1,
    unitTypes: [
      {
        id: 1,
        unitName: 'Video',
        unitIcon: <i class="fas fa-video"></i>,
      },
      {
        id: 2,
        unitName: 'Youtube',
        unitIcon: <i class="fab fa-youtube"></i>,
      },
      {
        id: 3,
        unitName: 'Audio',
        unitIcon: <i class="fas fa-microphone"></i>,
      },
      {
        id: 4,
        unitName: 'Quiz',
        unitIcon: <i class="fas fa-question"></i>,
      },
      {
        id: 5,
        unitName: 'Live Class',
        unitIcon: <i class="fas fa-wifi"></i>,
      },
      {
        id: 6,
        unitName: 'Course',
        unitIcon: <i class="fas fa-bars"></i>,
      },
      {
        id: 7,
        unitName: 'Text',
        unitIcon: <i className="fas fa-file-word"></i>,
      },
    ],
    trainerOptions: [
      {
        id: 1,
        name: 'CONTENT',
        subname: '0 inactive',
        icons: <i class="fas fa-th"></i>,
      },
      {
        id: 2,
        name: 'USERS & PROGRESS',
        subname: '1 instructor · 0 learners',
        icons: <i class="fas fa-user"></i>,
      },
      {
        id: 3,
        name: 'FILES',
        subname: '0 files',
        icons: <i class="fas fa-folder-open"></i>,
      },
      {
        id: 4,
        name: 'RULES & PATH ',
        subname: 'Sequential rule set',
        icons: <i class="fas fa-chart-line"></i>,
      },
      {
        id: 5,
        name: 'REPORTS',
        subname: 'No Reports',
        icons: <i class="fas fa-chart-pie"></i>,
      },
    ],
  };
  enableCourseName = () => {
    this.setState({enableCourseName: true});
  };
  enableCourseDisc = () => {
    this.setState({enableCourseDisc: true});
  };
  closeNameEditing = () => {
    this.setState({enableCourseName: false});
  };
  closeDiscEditing = () => {
    this.setState({enableCourseDisc: false});
  };
  onInputChange = e => {
    this.setState({[e.target.name]: e.target.value});
  };
  onSelectUnit = id => {
    this.setState({selectedUnitType: id});
    if (id == 6) {
      window.location.href = `#/create-course/${this.props.match.params.course_id}`;
    } else if (id == 4) {
      window.location.href = `#/create-quiz/${this.props.match.params.course_id}`;
    }
  };
  onSelectedOptions = id => {
    this.setState({selectedOption: id});
  };

  componentDidMount() {
    this.getCourse();
  }

  getCourse() {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', localStorage.getItem('livelms_auth'));

    var urlencoded = new URLSearchParams();
    urlencoded.append('siteId', localStorage.getItem('lms_site_id'));
    urlencoded.append('courseId', this.props.match.params.course_id);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    fetch(Constant.getAPI() + '/course/getOne', requestOptions)
      .then(response => response.json())
      .then(result => {
        var data = result.data;
        console.log(data);

        this.setState({
          name: data.name,
        });
        this.setState({course: data, loading: false});
      })
      .catch(error => console.log('error', error));
  }
  render() {
    const courseID = this.props.match.params.course_id;
    return (
      <div className="py-4">
        <div className="container create-course border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /
                  <Link to="/admin/courses">Course</Link> /
                  <Link to={`/admin/course/topics/${courseID}`}>
                    {this.state.name}
                  </Link>{' '}
                  / Add Topic
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8 left-section border-right">
              <div className="p-2 my-2">
                <h5>Select Topic Type</h5>
                <div className="d-flex">
                  {this.state.unitTypes.map(type => (
                    <div className="m-2">
                      <div
                        className={`card card-selector shadow-sm p-1 ${
                          type.id == this.state.selectedUnitType
                            ? 'selected'
                            : ''
                        }`}
                        onClick={this.onSelectUnit.bind(this, type.id)}>
                        <div className="d-flex justify-content-center align-items-center flex-column">
                          <div className="icon">{type.unitIcon}</div>
                          {type.unitName}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="unit-container">
                <div className="p-2 my-2">
                  {this.state.selectedUnitType == 1 ? (
                    <Video data={courseID} />
                  ) : this.state.selectedUnitType == 2 ? (
                    <Youtube data={courseID} />
                  ) : this.state.selectedUnitType == 3 ? (
                    <Audio data={courseID} />
                  ) : this.state.selectedUnitType == 5 ? (
                    <ZoomLive data={courseID} />
                  ) : this.state.selectedUnitType === 7 ? (
                    <TextPdf data={courseID} />
                  ) : this.state.selectedUnitType === 8 ? (
                    {
                      /*//HTML will be here */
                    }
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
